import { Controller } from "@hotwired/stimulus"
import { createEchoSocket } from "../chat/echo-socket.js"

// Live odświeżanie listy zadań: nowe zadanie przypisane do mnie wskakuje na listę
// bez ręcznego odświeżania. Nasłuchuje kanału notify:user w Echo (te same eventy
// "notification", które zasilają dzwonek - Rails publikuje je przy add_notification,
// więc łapiemy też zadania z API/automatyzacji; zero zmian w Echo). Montowany
// TYLKO na widoku "moje zadania" posortowanym od najnowszych (warunek w ERB) -
// przy innych filtrach/sortowaniach doklejanie na górę kłamałoby.
// Odświeżenie = reload turbo-frame'a z listą (serwer renderuje jak zwykle).
export default class extends Controller {
  static values = {
    // kindy notyfikacji oznaczające "nowe zadanie dla mnie" - UWAGA: to kind
    // z Account::NotificationType (payload eventu), nie code typu
    // (task_mine -> kind "task_create", task_group -> "task_group")
    kinds: { type: Array, default: ["task_create", "task_group"] },
    frameId: { type: String, default: "organize_task_list" },
  }

  connect() {
    // config socketu wystawia notifier dzwonka (renderowany w navbarze na każdej stronie)
    const configEl = document.getElementById("live-notifier-config")
    if (!configEl || !configEl.dataset.config) return
    let config = null
    try { config = JSON.parse(configEl.dataset.config) } catch { config = null }
    if (!config || !config.echo) return

    this.pendingRefresh = false
    this.onVisible = () => {
      if (this.pendingRefresh && !document.hidden) this.refresh()
    }
    document.addEventListener("visibilitychange", this.onVisible)

    this.socket = createEchoSocket(config.echo)
    this.socket.connect()
    const topic = `notify:user/${config.echo.params.account_id}/${config.echo.params.user_id}`
    this.channel = this.socket.channel(topic, {})
    this.channel.on("notification", payload => this.onNotification(payload))
    this.channel.join()
  }

  disconnect() {
    clearTimeout(this.refreshTimer)
    document.removeEventListener("visibilitychange", this.onVisible)
    if (this.channel) this.channel.leave()
    if (this.socket) this.socket.disconnect()
  }

  onNotification(payload) {
    if (!this.kindsValue.includes(payload.kind)) return
    if (!String(payload.dedup_key || "").startsWith("Organize::Task:")) return

    // debounce: seria notyfikacji (np. import zadań) = jedno przeładowanie listy
    clearTimeout(this.refreshTimer)
    this.refreshTimer = setTimeout(() => {
      if (document.hidden) {
        this.pendingRefresh = true // karta w tle - odświeżymy przy powrocie
      } else {
        this.refresh()
      }
    }, 1500)
  }

  refresh() {
    this.pendingRefresh = false
    const frame = document.getElementById(this.frameIdValue)
    if (!frame) return

    // zapamiętujemy widoczne zadania - po przeładowaniu podświetlimy te, których nie było
    this.knownTaskIds = new Set([...frame.querySelectorAll("li[id$='_list_element']")].map(el => el.id))
    frame.addEventListener("turbo:frame-load", () => this.highlightNew(frame), { once: true })
    // frame bez src: ustawienie src na bieżący URL pobiera stronę i podmienia
    // sam frame (filtry, sortowanie i paginacja zostają z aktualnych parametrów)
    frame.src = window.location.href
  }

  // chwilowe tło nowego wpisu - widać, że coś właśnie doszło; !bg-* wygrywa
  // z pasami even:bg-gray-50 wierszy, paleta yellow-50 jest mapowana w dark mode
  highlightNew(frame) {
    if (!this.knownTaskIds) return
    frame.querySelectorAll("li[id$='_list_element']").forEach(el => {
      if (this.knownTaskIds.has(el.id)) return
      el.classList.add("!bg-yellow-50")
      setTimeout(() => {
        el.classList.add("transition-colors", "duration-1000")
        el.classList.remove("!bg-yellow-50")
      }, 2500)
      setTimeout(() => el.classList.remove("transition-colors", "duration-1000"), 3800)
    })
  }
}
